module.exports = __webpack_public_path__ + "img/txm.3b6d7293.jpg";